<template>
  <div class="item-inner">
    <div class="item-title label" style="width: 60%;">{{this.attribute.label}}</div>
    <div class="item-input">
      <input  type="text" :value="attribute.valueText"  readonly="readonly">
    </div>
  </div>
  <!--
  <div class="item-inner">
    <div class="item-title label">E-mail</div>
    <div class="item-input">
      <input type="email" placeholder="E-mail">
    </div>
  </div>
  -->
</template>

<script>
//  import $ from 'jquery'
  export default {
    name: 'attr-gene-box',
    data () {
      return {
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {
    },
    computed: {
      options () {
        if (this.attribute.options) {
          return this.attribute.options
        }
        return {}
      }
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
</style>



// WEBPACK FOOTER //
// AttrGeneInfoBox.vue?41578fd1